import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { daysLeft } from "@/lib/plans";

export default function PlanBanner() {
  const { t, can, online } = useApp();
  const nav = useNavigate();
  const [b, setB] = useState(null);
  const allowed = can("billing");
  useEffect(() => { if (allowed && online) api.get("/billing").then((r) => setB(r.data)).catch(() => {}); }, [allowed, online]);
  if (!b) return null;
  const left = daysLeft(b.trial_ends);
  let msg = null;
  if (b.status === "trial" && left <= 3) msg = t("trial_days_left", { n: left });
  else if (b.status === "expired") msg = t("trial_over");
  if (!msg) return null;
  return (
    <button type="button" onClick={() => nav("/billing")} data-testid="plan-banner"
      className="w-full flex items-center justify-center gap-2 bg-[#FFF4D6] border-b border-[#F0D58A] text-[#7A5A12] text-sm font-bold py-2 px-3">
      <Sparkles className="w-4 h-4" />{msg}<span className="underline">{t("see_plans")}</span>
    </button>
  );
}
